import { z } from "zod";

export const RepresentativeSchema = z.object({
    full_name: z.string().min(1, "Representative name is required"),
    email: z.string().email("Invalid representative email").optional(),
    phone_number: z.string().optional(),
});

export const CreateArProfileSchema = z.object({
    company_code: z.string().min(1, "Company code is required"),
    company_name: z.string().min(1, "Company name is required"),
    address: z.string().min(1, "Address is required"),
    city: z.string().min(1, "City is required"),
    state: z.string().min(1, "State is required"),
    area: z.string().min(1, "Area is required"),
    country: z.string().min(1, "Country is required"),
    pincode: z.string().min(1, "Pincode is required"),
    building: z.string().min(1, "Building is required"),
    phone_number: z.string().min(1, "Phone number is required"),
    email: z.string().email("Invalid email"),
    tax_reg_no: z.string().min(1, "Tax registration number is required"),
    representative_person: RepresentativeSchema,
    website: z.string().url("Invalid website URL").optional(),
    iban: z.string().min(1, "IBAN is required"),
    account_number: z.string().min(1, "Account number is required"),
    bank_name: z.string().min(1, "Bank name is required"),
    bank_address: z.string().min(1, "Bank address is required"),
});

export type CreateArProfileSchema = z.infer<typeof CreateArProfileSchema>;
